import React, { useState,useEffect } from "react";
import { useLocation } from "react-router-dom";
import { COMMON_API } from "../../services/apiCalls/commonApi";
import { toast } from "react-toastify";

export default function PostHandoverComplaintForm({  onSubmit,rowData,setActiveTabIndex }) {
  const location = useLocation();
  console.log(rowData,"rowData")
  const pro = location.state || {};
  console.log(pro);
  const [showComplaintList, setShowComplaintList] = useState(false);

  const [formData, setFormData] = useState({
   
    state: "",
    
    spoc: "",
    product: "",
    complaintDescription: "",
    complaintCategories: "",
    handoverDate: "",
    warrentyCompletionDate: "",
    complaintRaisedOn: "",
    complaintStatus: "",
    finalComplaintRectifiedDate: "",
    pendingWork: "",
    expectedDate:"",
    resolutionTime:"",
    resolvingDelay:"",
    remarks:"",
    financialYear:"",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const resetFields = () => {
    setFormData({
        state: "",
        spoc: "",
        product: "",
        complaintDescription: "",
        complaintCategories: "",
        handoverDate: "",
        warrentyCompletionDate: "",
        complaintRaisedOn: "",
        complaintStatus: "",
        finalComplaintRectifiedDate: "",
        pendingWork: "",
        expectedDate: "",
        resolutionTime: "",
        resolvingDelay: "",
        remarks: "",
        financialYear: "",
    });
};

  const handleSubmit = async (e) => {
  for (const key in formData) {
    if (!formData[key]) {
        toast.error("Please fill in all fields!", { autoClose: 2000 });
        return; 
    }
}
    if (onSubmit) onSubmit();

    e.preventDefault(); 
    const state = JSON.parse(localStorage.getItem("state"));
    let obj = {
      ProjectId: pro?.project_id,
      ProjectName: pro?.Project_Name,
      Location: pro?.Location,
      State: formData?.state,
      SPOC: formData?.spoc,
      Product: formData?.product,
      ComplaintDescription: formData?.complaintDescription,
      ComplaintCategories: formData?.complaintCategories,
      HandoverDate: formData?.handoverDate,
      WarrantyCompletionDate: formData?.warrentyCompletionDate,
      ComplaintsRaisedOn: formData?.complaintRaisedOn,
      Status: formData?.status,
      FinalComplaintRectifiedDate: formData?.finalComplaintRectifiedDate,
      PendingWork: formData?.pendingWork,
      ExpectedDateOfServiceTeamVisit: formData?.expectedDate,
      ResolutionTime: formData?.resolutionTime,
      DelayInResolvingTheIssueTillDate: formData?.resolvingDelay,
      Remarks: formData?.remarks,
      ComplaintsRaisedFinancialYear: formData?.financialYear,
      UserID: state.user.user_id,
      ID:rowData?.ID
    };
    const savePostHandover = await COMMON_API.createPostHandoverComplaintForm(obj);
    if (savePostHandover && savePostHandover?.status === 201) {
      toast.success(savePostHandover?.Message, { autoClose: 2000 });
      resetFields()
      setActiveTabIndex(1)
    } else {
      toast.error(savePostHandover?.Message, { autoClose: 2000 });
    }
  };
  const cancelAction = async (e) =>{
    resetFields();
    setActiveTabIndex(1);
  }
    useEffect(() => {
              
              if (rowData) {
                  console.log(rowData,"rowData")
                setFormData({
                  projectId: rowData?.ProjectId || "",
                  projectName: rowData.ProjectName || "",
                  state: rowData?.State,
                  location: rowData?.Location,
                  spoc: rowData?.SPOC,
                  product: rowData?.Product,
                  complaintDescription: rowData?.ComplaintDescription,
                  complaintCategories: rowData?.ComplaintCategories,
                  handoverDate: rowData?.HandoverDate,
                  warrentyCompletionDate: rowData?.WarrantyCompletionDate,
                  complaintRaisedOn: rowData?.ComplaintsRaisedOn,
                  complaintStatus:rowData?.Status,
                  finalComplaintRectifiedDate: rowData?.FinalComplaintRectifiedDate,
                  pendingWork: rowData?.PendingWork,
                  expectedDate:rowData?.ExpectedDateOfServiceTeamVisit,
                  resolutionTime:rowData?.ResolutionTime,
                  resolvingDelay:rowData?.DelayInResolvingTheIssueTillDate,
                  remarks: rowData?.Remarks,
                  financialYear: rowData?.ComplaintsRaisedFinancialYear, 
                });
             
                console.log("formData",formData)
              }

            }, []);

  return (
    // <form onSubmit={handleSubmit}>
    <>
      <div className="row">
        <div className="col-6">
          <label className="label-custom">Project Name</label>
          <input
            disabled
            type="text"
            name="projectName"
            value={pro?.Project_Name}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Location</label>
          <input
            disabled
            type="text"
            name="location"
            value={pro?.Location}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
      <div className="col-6">
          <label className="label-custom">State</label>
          <input
           
            type="text"
            name="state"
            value={formData.state}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        
        <div className="col-6">
          <label className="label-custom">SPOC</label>
          <input
            type="text"
            name="spoc"
            value={formData.spoc}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Product</label>
          <input
            type="text"
            name="product"
            value={formData.product}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Complaint Description</label>
          <textarea
            name="complaintDescription"
            value={formData.complaintDescription}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Complaint Categories</label>
          <select
            name="complaintCategories"
            value={formData.complaintCategories}
            className="form-control shadow-none"
            style={{
              width: "100%",
              height: 31,
              border: "1px solid #e6e3e3",
              borderRadius: 4,
              color: "rgb(211, 206, 206)",
            }}
            onChange={handleChange}
           
          >
             <option value="">Complaint Categories</option>
            <option value="one">One</option>
            <option value="two">Two</option>
            <option value="three">Three</option>
            </select>
        </div>
        <div className="col-6">
          <label className="label-custom">Handover Date</label>
          <input
            type="date"
            name="handoverDate"
            value={formData.handoverDate}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Warrenty Completion Date</label>
          <input
            type="date"
            name="warrentyCompletionDate"
            value={formData.warrentyCompletionDate}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Complaints raised on</label>
          <input
          type="date"
            name="complaintRaisedOn"
            value={formData.complaintRaisedOn}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Status</label>
          <select
            name="complaintStatus"
            value={formData.complaintStatus}
            className="form-control shadow-none"
            style={{
              width: "100%",
              height: 31,
              border: "1px solid #e6e3e3",
              borderRadius: 4,
              color: "rgb(211, 206, 206)",
            }}
            onChange={handleChange}
          >
            <option value="">Select Status</option>
            <option value="Open">Open</option>
            <option value="Close">Close</option>
          </select>
        </div>
        <div className="col-6">
          <label className="label-custom">Final complaint rectified date</label>
          <input
            type="date"
            name="finalComplaintRectifiedDate"
            value={formData.finalComplaintRectifiedDate}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Pending work</label>
          <input
            type="text"
            name="pendingWork"
            value={formData.pendingWork}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Expected date of service team visit</label>
          <input
            type="date"
            name="expectedDate"
            value={formData.expectedDate}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Resolution time</label>
          <input
            type="text"
            name="resolutionTime"
            value={formData.resolutionTime}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Delay in resolving the issuetill date</label>
          <input
            type="date"
            name="resolvingDelay"
            value={formData.resolvingDelay}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Remarks</label>
          <input
            type="text"
            name="remarks"
            value={formData.remarks}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Complaint Raised Financial Year</label>
          <input
            type="text"
            name="financialYear"
            value={formData.financialYear}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-4 pb-3">
        <div className="d-flex justify-content-center">
          <div className="m-2">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              
              
            >
              Submit
            </button>
          </div>
          <div className="m-2">
          <button
    type="button"
    className="btn btn-danger"
   onClick={ cancelAction}
>
    Cancel
</button>
          </div>
        </div>
      </div>
    </>
  );
}
